<template>
  <div class="row">
    <div class="col-10 offset-1">
      <h2 class="form-head">Dashboard</h2>
    </div>
    <div class="col-10 offset-1">
      <table class="table table-striped">
        <thead class="thead-dark">
        <tr>
          <th>Date</th>
          <th>State</th>
          <th>Generated</th>
          <th>Cancelled</th>
          <th>NO Part-B</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="h of highlights" :key="h.dt + h.state">
          <td>{{h.dt}}</td>
          <td>{{h.state}}</td>
          <td>{{h.generated}}</td>
          <td>{{h.cancelled}}</td>
          <td>{{h.noPartB}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'

export default {
  name: 'HomePage',
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (!this.$store.state.loggedIn) {
        console.log('Not Logged-in')
        this.$router.push('login')
      }
    }, _ => {
      console.error('isLoggedIn Failed, lets go to login')
      this.$router.push('login')
    })
  },
  data () {
    return {
      last: 7,
      highlights: [],
      stateMap: {}
    }
  },
  mounted () {
    this.loadData()
  },
  computed: {
  },
  methods: {
    loadData: function () {
      console.log('Fetch Data from API for Charts')
      axios.get(`/app/chart/highlights?last=${this.last}`)
        .then(response => {
          this.highlights = response.data
          this.stateMap = _.groupBy(this.highlights, 'stateName')
        }, error => {
          console.error('Error in fetching Highlights', error)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

a {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/EWBHomePage.vue